export const MAINTENANCE_MODE = 'pAAR2945PayexMaintenanceMode';
export const CAMELIZED_FEATURES = [MAINTENANCE_MODE] as const;
export const ENABLE_FEATURE = 'ENABLE_FEATURE';
export const FETCH_FEATURES_REQUEST = 'FETCH_FEATURES_REQUEST';
export const FETCH_FEATURES_SUCCESS = 'FETCH_FEATURES_SUCCESS';
export const FETCH_FEATURES_ERROR = 'FETCH_FEATURES_ERROR';
export const FF_HOLIDAY_BANNER_CN = 'PAAR-5353-holidayBannerCN';
export const FF_HOLIDAY_BANNER_IN = 'PAAR-6343-holidayBannerIN';
export const FF_HOLIDAY_BANNER_VN = 'PAAR-5353-holidayBannerVN';
export const FF_CAPTCHA = 'PAAR-4218-VerifyTokenInBackend';
export const FF_PAYING_FROM_INDIA_IN_USD = 'PAAR-5643-Mario';
export const FF_BANNER_COUPONS_CN = 'REM-1374-bannerCouponsCN';
export const FF_HIDE_KYC_BUTTON = 'PAAR-5826-hideKycButton';
export const FF_STUDENT_EXPENSES_PAYMENTS = 'REM-1383-StudentExpensesPayments';
export const FF_ACADEMIC_FIELDS = 'REM-1508-AcademicFields';
export const FF_PAY_INSTALLMENT = 'PAAR-6035-pay-installment';
export const FF_MANDATORY_ACCOUNT_INDIA = 'LOOP-1399-MandatoryAccountIndia';
export const FF_MANDATORY_ACCOUNT_INDIA_VERSION =
  'LOOP-1399-MandatoryAccountIndiaVersion';
export const FF_MANDATORY_ACCOUNT_CHINA = 'LOOP-1527-MandatoryAccountChina';
export const FF_MANDATORY_ACCOUNT_CHINA_VERSION =
  'LOOP-1527-MandatoryAccountChinaVersion';
export const FF_NEW_PAYMENT_INFO_STEP = 'PAAR-6331-NewPaymentInfoStep';
export const FF_NEW_INDIA_WIZARD = 'PAAR-6332-NewIndiaWizard';
export const FF_DOC_COLLECTOR_VISUAL_IMPROVEMENTS =
  'LOOP-1621-DocCollectorVisualImprovements';

export const FF_SKIP_INVALID_STATE_ERROR = 'PAAR-6365-SkipInvalidStateError';

export const DISABLE_OLD_COOKIES_BANNER = 'pAAR5317DisableOldCookiesBanner';
export const FF_OLD_COOKIES_BANNER_DISABLED =
  'PAAR-5317-DisableOldCookiesBanner';

export const FEATURES = [
  'PAAR-2945-payex_maintenance_mode',
  FF_HOLIDAY_BANNER_CN,
  FF_HOLIDAY_BANNER_IN,
  FF_HOLIDAY_BANNER_VN,
  FF_PAYING_FROM_INDIA_IN_USD,
  FF_BANNER_COUPONS_CN,
  FF_HIDE_KYC_BUTTON,
  FF_STUDENT_EXPENSES_PAYMENTS,
  FF_ACADEMIC_FIELDS,
  FF_PAY_INSTALLMENT,
  FF_NEW_PAYMENT_INFO_STEP,
  FF_NEW_INDIA_WIZARD,
  FF_DOC_COLLECTOR_VISUAL_IMPROVEMENTS,
  FF_SKIP_INVALID_STATE_ERROR,
  FF_OLD_COOKIES_BANNER_DISABLED,
] as const;

const FEATURE_TYPES = [FF_CAPTCHA] as const;

const FEATURE_ABC_TEST = [
  FF_MANDATORY_ACCOUNT_INDIA,
  FF_MANDATORY_ACCOUNT_INDIA_VERSION,
  FF_MANDATORY_ACCOUNT_CHINA,
  FF_MANDATORY_ACCOUNT_CHINA_VERSION,
] as const;

export type FeatureFlag =
  | (typeof FEATURES)[number]
  | (typeof FEATURE_TYPES)[number]
  | (typeof FEATURE_ABC_TEST)[number];
